import PlantOverviewStore from "./PlantOverview/PlantOverview.Store";

const operationsStoreList = [
    { name: "plantOverviewStore", store: PlantOverviewStore },
];

export default operationsStoreList;